import { BaseModel, PaginationDataModel, convertToArrayModels, convertToModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { PaginationData } from '~/shared/interfaces'
import DigitalLectureSpeakerCard from '../detail/DigitalLectureSpeakerCard'

export default class DigitalLectureSpeakerListResult extends BaseModel {
  static override constructorName = 'DigitalLectureSpeakerListResult'

  items: DigitalLectureSpeakerCard[] = []
  pagination: PaginationData = new PaginationDataModel()

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.items = convertToArrayModels(data.data, DigitalLectureSpeakerCard)

      this.pagination = convertToModel(data.meta, PaginationDataModel, this.pagination)
    }
  }
}

registerModel(DigitalLectureSpeakerListResult)
